import { combineReducers } from 'redux-immutable'

import data from './data'
import ui from './ui'

export default combineReducers({
  data,
  ui
})
